<template>
  <el-radio-group
    :class="[isEmpty(position) ? '' : 'absolute-el', 'tab-switch']"
    :style="{ ...position, ...customStyle }"
    @change="(value: string) => onRadioChange(value)"
    v-model="switchValue"
  >
    <el-radio-button v-for="item in data" :key="item.key" :label="item.key">{{ item.label }}</el-radio-button>
  </el-radio-group>
</template>

<script lang="ts" setup>
import { ref, watch } from "vue"
import { isEmpty } from "lodash-es"
import { ElRadioGroup, ElRadioButton } from "element-plus"

interface Item {
  key: string
  label: string
}

const switchValue = ref<string>("")

const emits = defineEmits(["change"])

const props = withDefaults(
  defineProps<{
    id: string
    position?: any
    customStyle?: any
    data: Item[]
    defaultKey: string
  }>(),
  {},
)

watch(
  () => {
    props.defaultKey
  },
  key => {
    switchValue.value = props.defaultKey
  },
  {
    immediate: true,
    deep: true,
  },
)

// defineEmits(['onChange']);

function onRadioChange(value: string) {
  const data = props.data.find(item => item.key === value)
  emits("change", [value, data])
  // EventBus.emit(`${props.id}-onChange`, [value, data])
}
</script>

<style lang="scss">
.tab-switch label.el-radio-button span.el-radio-button__inner {
  background-color: #08102b !important;
  color: #fff !important;
}

.tab-switch label.el-radio-button.is-active span.el-radio-button__inner {
  background-color: #3870d4 !important;
  color: #fff !important;
}
</style>
